import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import TermsOfServiceDialog from './TermsOfServiceDialog';

/**
 * 학교운영위원회 심의 및 관련 법령 준수를 위한 Footer
 * - 개인정보처리방침 링크 (MARU 정책 페이지로 이동)
 * - 이용약관 링크 (클릭 시 팝업)
 * - 개인정보책임자 실명, 소속 학교, 연락처
 */
const Footer: React.FC = () => {
  const [isTermsOpen, setIsTermsOpen] = useState(false);

  return (
    <>
      <footer
        style={{
          width: '100%',
          padding: '16px 24px',
          marginTop: 'auto',
          backgroundColor: 'var(--Color-fill-normal, #293044)',
          color: 'var(--Color-text-assistive, #989898)',
          flexShrink: 0
        }}
      >
        <div
          style={{
            maxWidth: '1200px',
            margin: '0 auto',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: '8px'
          }}
        >
          {/* 저작권 및 링크 */}
          <div
            style={{
              fontSize: '14px',
              textAlign: 'center',
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '8px'
            }}
          >
            <span>© 2026 Maru. All rights reserved.</span>
            <span style={{ color: 'var(--Color-text-assistive, #989898)' }}>|</span>
            <span
              style={{
                color: 'var(--Color-text-assistive, #989898)',
                cursor: 'pointer',
                textDecoration: 'underline'
              }}
              onClick={() => setIsTermsOpen(true)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === 'Enter' && setIsTermsOpen(true)}
            >
              이용약관
            </span>
            <span style={{ color: 'var(--Color-text-assistive, #989898)' }}>|</span>
            <Link
              to="/policy"
              style={{
                color: 'var(--Color-text-inverse, white)',
                textDecoration: 'underline',
                fontWeight: 500
              }}
            >
              개인정보처리방침
            </Link>
          </div>
          <div
            style={{
              fontSize: '12px',
              textAlign: 'center',
              color: 'var(--Color-text-assistive, #989898)',
              display: 'flex',
              flexWrap: 'wrap',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '8px',
              lineHeight: '18px',
            }}
          >
            <span>이름: 한지호 교사 (서울용강중학교)</span>
            <span>|</span>
            <a
              href="mailto:jihotech16@outlook.kr"
              style={{ color: 'inherit', textDecoration: 'underline' }}
            >
              이메일: jihotech16@outlook.kr
            </a>
            <span>|</span>
            <a
              href="tel:010-4905-0554"
              style={{ color: 'inherit', textDecoration: 'underline' }}
            >
              문의: 010-4905-0554
            </a>
          </div>
        </div>
      </footer>
      <TermsOfServiceDialog isOpen={isTermsOpen} onClose={() => setIsTermsOpen(false)} />
    </>
  );
};

export default Footer;
